// Lodash
import { isEqual, get } from 'lodash'
import URL from 'url'
import Cookies from 'js-cookie'

export const hasChanged = (object1, object2, path) =>
  !isEqual(get(object1, path), get(object2, path))

export const pageFromProps = (props) => {
  const page = parseInt(get(props, 'location.query.page') || '1', 10)
  if (typeof (page) !== 'number') return 1
  return page
}

export const query = (props, fieldName) =>
  get(props, ['location', 'query', fieldName])

export const formatMoney = (value) => {
  let number = parseFloat(parseFloat(value).toPrecision(15))
  // const chunks = number.toString().split('.')
  // if (chunks.length === 1) {
  //   number = number.toFixed(2)
  // } else if (chunks.length > 1 && chunks[1].length < 2) {
  //   number = number.toFixed(2)
  // }
  return (Math.round(number * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

export const isNotNumber = (value) => {
  return isNaN(value)
  // const number = parseFloat(value)
  // return value !== number || typeof (number) !== 'number'
}

export const viewportWidth = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const iOSSafari = () => {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
  const webkit = !!ua.match(/WebKit/i)
  return iOS && webkit && !ua.match(/CriOS/i)
}

export const freezeScreen = () => {
  if (typeof document !== 'undefined') {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    document.getElementsByTagName('html')[0].style.top = `-${scrollY}px`

    if (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)) {
      document.getElementsByTagName('html')[0].style.position = 'fixed'
    }
  }
}
export const unfreezeScreen = () => {
  if (typeof document !== 'undefined') {
    const top = parseInt(document.getElementsByTagName('html')[0].style.top.replace('px', '').replace('-', ''), 10)
    setTimeout(() => {
      document.body.scrollTop = top
      document.documentElement.scrollTop = top
    })

    document.getElementsByTagName('html')[0].style.overflow = null
    document.getElementsByTagName('html')[0].style.top = null
    if (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)) {
      document.getElementsByTagName('html')[0].style.position = null
    }
  }
}

export const offset = (el) => {
  const rect = el.getBoundingClientRect()

  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

const PREFIX = `${process.env.NODE_ENV === 'development' ? 'http://dev.chatchaipharmacy.com' : ''}/services/api`
export const apiFetch = ({ endpoint, query }) =>
  fetch(`${PREFIX}${endpoint}${URL.format({ query })}`, { // eslint-disable-line
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'Token': Cookies.get('token')
    }
  })
    .then(res =>
      res.text()
        .then(text => Promise.resolve(text ? JSON.parse(text) : {}))
        .then(json => res.status === 200
          ? Promise.resolve(json)
          : Promise.reject({ statusCode: res.status, err: json }) // eslint-disable-line
        )
    )
    .then(result => {
      return Promise.resolve(result)
    })
    .catch(error => {
      return Promise.reject(error)
    })



/** WEBPACK FOOTER **
 ** ./src/helpers/utilities.js
 **/